import React from 'react';
import '../css/custom.css';

function ScreenConfiguration({maxLEDWidth, maxLEDHeight, panelDetails, finalresWidth, finalresHeight, aspectRatio, DiagonalDis, overallDistance}) { 

    return (
        <div className="mt-5">
            <table className="table table-bordered">
                <thead>
                    <tr>
                       <th colSpan="2" className="text-white p-3" id="bg-primary"><h4>Screen Configuration</h4></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row" className="pt-3">Single Panel Size</th>
                        <td className="text-center" id="text-primary">
                            {panelDetails.panelWidth ? `${panelDetails.panelWidth} x` : '-'} {panelDetails.panelHeight ? `${panelDetails.panelHeight} (Ft)` : ''}
                            <br/>
                            {panelDetails.panelWidthmm ? `${panelDetails.panelWidthinch} x` : ''} {panelDetails.panelHeightmm ? `${panelDetails.panelHeightinch} (Inch)` : ''}
                            <br/>
                            <div>{panelDetails.panelWidthmm ? `${panelDetails.panelWidthmm} x` : ''} {panelDetails.panelHeightmm ? `${panelDetails.panelHeightmm} (mm)` : ''}</div>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">Resolution</th>
                        <td className="text-center" id="text-primary">{panelDetails.resolutionWidth ? `${finalresWidth} x ${finalresHeight}` : '-' }</td>
                    </tr>
                    <tr>
                        <th scope="row">Panel Array</th>
                        <td className="text-center" id="text-primary">{aspectRatio ? `${(maxLEDWidth/ panelDetails.panelWidth).toFixed(0)} x ${(maxLEDHeight/ panelDetails.panelHeight).toFixed(0)}` : '-'}</td>
                    </tr>
                    <tr>
                        <th scope="row">Total Panels</th>
                        <td className="text-center" id="text-primary">{aspectRatio ? `${(maxLEDWidth / panelDetails.panelWidth).toFixed(0) * (maxLEDHeight / panelDetails.panelHeight).toFixed(0)}` : '-'}</td>
                    </tr>
                    <tr>
                        <th scope="row"><span className="star-mark">*</span>Max Power Consumption - {panelDetails.perCabinetMax ? `${panelDetails.perCabinetMax} W` : ''} (Per Panel) </th>
                        
                        <td className="text-center" id="text-primary">
                            {
                                panelDetails.perCabinetMax
                                ? `${(panelDetails.perCabinetMax * (maxLEDWidth / panelDetails.panelWidth).toFixed(0) * (maxLEDHeight / panelDetails.panelHeight).toFixed(0)).toFixed(0)} W`
                                : '-'
                            }
                        </td>
                    </tr>
                    <tr>
                        <th scope="row"><span className="star-mark">*</span>Avg Power Consumption - {panelDetails.perCabinetMin ? `${panelDetails.perCabinetMin} W` : ''} (Per Panel)</th>
                        <td className="text-center" id="text-primary">
                            {
                                panelDetails.perCabinetMin
                                ? `${(panelDetails.perCabinetMin * (maxLEDWidth / panelDetails.panelWidth).toFixed(0) * (maxLEDHeight / panelDetails.panelHeight).toFixed(0)).toFixed(0)} W`
                                : '-'
                            }
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">Aspect Ratio</th>
                        <td className="text-center" id="text-primary">{panelDetails.panelWidthmm ? `${aspectRatio.toFixed(2)} : 1` : '-'}</td>
                    </tr>
                    <tr>
                        <th scope="row">Display Diagonal Distance</th>
                        <td className="text-center" id="text-primary">
                            {aspectRatio ? `${(Math.sqrt(DiagonalDis) * 12).toFixed(2)} (Inch)` : '-'}<br/>
                            {aspectRatio ? `${(Math.sqrt(DiagonalDis) * 12 * 25.4).toFixed(2)} (mm)` : '-'}
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">Overall Diagonal Distance - (Frame Border {panelDetails.frameSize}mm)</th>
                        <td className="text-center" id="text-primary">
                            {aspectRatio ? `${(Math.sqrt(overallDistance) * 12).toFixed(2)} (Inch)` : '-'}<br/>
                            {aspectRatio ? `${(Math.sqrt(overallDistance) * 12 * 25.4).toFixed(2)} (mm)` : '-'}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default ScreenConfiguration;
